import { useEffect, useState } from 'react';
import * as zy from '../../common/zeroyear-1.0.0';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
let sessionStorage = window.sessionStorage;

export default function Footer () {
    const [admin, setAdmin] = useState(false);
    const [data, setData] = useState([]);
    const [editData, setEditData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const selectFooter = () => {
        zy.select('selectFooter', [], (item) => {
            setData(item[0]);
        });
    };
    const openModal = () => { 
        setEditData({...data});
        setShowModal(true);
    };
    const closeModal = () => {
        setEditData({...data});
        setShowModal(false);
    };
    const saveFooter = () => {
        zy.modify('updateFooter', [
            editData.FOOT_COMP_NM,editData.FOOT_CEO_NM,editData.FOOT_COMP_NO,editData.FOOT_COMP_ADDR,editData.FOOT_COMP_TEL,editData.FOOT_COMP_FAXA,editData.FOOT_COMP_EMAIL, editData.FOOT_COMP_LATITUDE, editData.FOOT_COMP_LONGITUDE
        ], (item) => {
            if (item.affectedRows > 0) {
                // 저장 완료
                selectFooter();
                closeModal();
            }
        });
    };
    const changeCompNm = (event) => { setEditData({...editData, FOOT_COMP_NM: event?.target.value}); } // 상호명
    const changeCeoNm = (event) => { setEditData({...editData, FOOT_CEO_NM: event?.target.value}); } // 대표자
    const changeCompNo = (event) => { setEditData({...editData, FOOT_COMP_NO: event?.target.value}); } // 사업자등록번호
    const changeAddr = (event) => { setEditData({...editData, FOOT_COMP_ADDR: event?.target.value}); } // 주소
    const changeTel = (event) => { setEditData({...editData, FOOT_COMP_TEL: event?.target.value}); } // TEL
    const changeFax = (event) => { setEditData({...editData, FOOT_COMP_FAXA: event?.target.value}); } // FAX
    const changeEmail = (event) => { setEditData({...editData, FOOT_COMP_EMAIL: event?.target.value}); } // E-mail
    const changeLaTude = (event) => { setEditData({...editData, FOOT_COMP_LATITUDE: event?.target.value}); } // E-mail
    const changeLoTude = (event) => { setEditData({...editData, FOOT_COMP_LONGITUDE: event?.target.value}); } // E-mail
    useEffect(() => {
        setAdmin(sessionStorage.getItem('isLogin'));
        selectFooter();
    }, []);
    return (
        <>
        <footer id="footer">
            <div className="container">
                {admin ? <button className="btn-cancel" onClick={openModal}>수정</button> : null}
                <div className="copyright">
                    &copy; <strong><span>GongGan Co</span></strong>, All Rights Reserved<br></br>
                    <strong><span>상호명</span></strong> <span>{data.FOOT_COMP_NM}</span> |
                    <strong><span> 대표자</span></strong> <span>{data.FOOT_CEO_NM}</span> |
                    <strong><span> 사업자등록번호</span></strong> <span>{data.FOOT_COMP_NO}</span> |
                    <strong><span> 주소</span></strong> <span>{data.FOOT_COMP_ADDR}</span>
                </div>
                <div className="credits">
                    <strong><span>TEL</span></strong> {data.FOOT_COMP_TEL} |
                    <strong><span> FAX</span></strong> {data.FOOT_COMP_FAXA} |
                    <strong><span> E-mail</span></strong> {data.FOOT_COMP_EMAIL}
                </div> 
            </div>
        </footer>
        <Modal 
        show={showModal}
        onHide={closeModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered>
        <Form noValidate>
            <Modal.Header closeButton>
            <Modal.Title>정보 수정</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_NM">
                    <Form.Label>상호명</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeCompNm}
                        placeholder=""
                        value={editData.FOOT_COMP_NM||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_CEO_NM">
                    <Form.Label>대표자</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        onChange={changeCeoNm}
                        value={editData.FOOT_CEO_NM||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_NO">
                    <Form.Label>사업자등록번호</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeCompNo}
                        placeholder=""
                        value={editData.FOOT_COMP_NO||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_ADDR">
                    <Form.Label>주소</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeAddr}
                        placeholder=""
                        value={editData.FOOT_COMP_ADDR||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_TEL">
                    <Form.Label>TEL</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeTel}
                        placeholder=""
                        value={editData.FOOT_COMP_TEL||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_FAXA">
                    <Form.Label>FAX</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeFax}
                        placeholder=""
                        value={editData.FOOT_COMP_FAXA||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_EMAIL">
                    <Form.Label>E-mail</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeEmail}
                        placeholder=""
                        value={editData.FOOT_COMP_EMAIL||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_LATITUDE">
                    <Form.Label>위도</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeLaTude}
                        placeholder=""
                        value={editData.FOOT_COMP_LATITUDE||''}
                        />
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="FOOT_COMP_LONGITUDE">
                    <Form.Label>경도</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={changeLoTude}
                        placeholder=""
                        value={editData.FOOT_COMP_LONGITUDE||''}
                        />
                </Form.Group>
                <Modal.Footer>
                    <button className="btn-cancel" type="button" onClick={closeModal}>닫기</button>
                    <button className="btn-normal" type="button" onClick={saveFooter}>수정</button>
                </Modal.Footer>
            </Modal.Body>
        </Form>
    </Modal>
    </>
    );
}